<div class="header-bar">
  <h1>Hold Status By Service Type</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="ui-g">
        <div class="ui-md-6 ui-g-12 ui-g-nopad">
          <p-table
            #dt
            selectionMode="single"
            [value]="items"
            [lazy]="false"
            [responsive]="true"
            [rowHover]="true"
            [loading]="isLoading"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Service Type</th>
                <th>Put into On-Hold Type</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item">
                <td>{{ item.taskTypeName }}</td>
                <td>
                  <p-checkbox [(ngModel)]="item.putIntoOnHold" binary="true"></p-checkbox>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!---
                    <p-dataTabl #dt selectionMode="single" [value]="items" [lazy]="false" [responsive]="true"
                             [rowHover]="true" [loading]="isLoading">
                        <p-column field="taskTypeName" header="Service Type"></p-column>
                        <p-column field="putIntoOnHold" header="Put into On-Hold">
                            <ng-template let-data="rowData" pTemplate="body">
                                <div style="text-align: center;">
                                    <p-checkbox [(ngModel)]="data.putIntoOnHold" binary="true"></p-checkbox>
                                </div>
                            </ng-template>
                        </p-column>
                    </p-dataTable>
                    --->
          <div class="footerPanel ui-grid-row">
            <button
              class="btn-to-right"
              type="button"
              (click)="save()"
              label="Save"
              [disabled]="isLoading"
              pButton
              icon="fa ui-icon-check"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
